module.exports = __webpack_public_path__ + "static/media/schedule-activated.99465c83.svg";